// extracted by mini-css-extract-plugin
export var avatar = "squorli-widget-module--avatar--25955";
export var flex = "squorli-widget-module--flex--32cc9";
export var game = "squorli-widget-module--game--44940";
export var idle = "squorli-widget-module--idle--c660a";
export var imageWrapper = "squorli-widget-module--imageWrapper--7e46d";
export var initials = "squorli-widget-module--initials--aea83";
export var muteWrapper = "squorli-widget-module--muteWrapper--fcf76";
export var mutedButton = "squorli-widget-module--mutedButton--a96a5";
export var online = "squorli-widget-module--online--a1e39";
export var squorliWidget = "squorli-widget-module--squorliWidget--bb296";
export var squorliWrapper = "squorli-widget-module--squorliWrapper--60ce1";
export var toggleButton = "squorli-widget-module--toggleButton--f8ce6";
export var userName = "squorli-widget-module--userName--e4aa1";
export var userWrapper = "squorli-widget-module--userWrapper--12cd3";